import { useSearchParams } from 'react-router-dom'

export const useDebugTranslationKeys = (): boolean => {
  const [searchParams] = useSearchParams()

  return searchParams.get('debugTranslationKeys') === 'true'
}
